import React from "react";
import './CarCategories.css';

import { Heading, Category } from "../../../components";
import { cars } from "../../../constants";
import { getPopularCarCategories } from "../../../utils";



const CarCategories = () => {

  // Get the Car Categories
  const categories = getPopularCarCategories(cars);

  // Top 5 categories
  const topCategories = categories.slice(0, 5);

  return (

    <section className="categories">

      {/* Section Heading */}
      <Heading title={'Explore Our Rental Cars'} span={'Car Categories'} />

      {/* Category Items */}
      <div className="box-container">

        {/* Map over the categories array to render each category */}
        {topCategories.map(({ index, category, count, image }) => (
          <Category
            key={index}
            index={index}
            category={category}
            count={count}
            image={image}
          />
        ))}

      </div>

    </section>

  );
};

export default CarCategories;